import axios from 'axios';

const cancel = [];

export const cancelAllRequests = () => {
	cancel.map((item) => {
		item[1]();
	});
};

export const axiosInstance = axios.create({
	withCredentials: false,
	timeout: 50000,
});

// Add a request interceptor
axiosInstance.interceptors.request.use(
	function (request) {
		request.headers['Content-Type'] = 'application/json';

		return request;
	},
	function (error) {
		return Promise.reject(error);
	},
);

// Add a response interceptor
axiosInstance.interceptors.response.use(
	function (response) {
		return response;
	},
	function (error) {
		return Promise.reject(error);
	},
);
